import React from 'react';
import styled from 'styled-components';
import { Text, Tag } from 'src/components/matchbox';

export const StyledIcon = styled.span`
  display: inline-block;
  margin-left: ${({ theme }) => theme.space[100]};
  transform: translateY(-1px);
`;

export const PriorityWrapper = styled.div``;

export const FiltersBar = styled.div`
  display: grid;
  grid-gap: ${(props) => props.theme.space['400']};
  grid-template-columns: 1fr;

  @media (min-width: ${(props) => props.theme.breakpoints[1]}) {
    grid-gap: ${(props) => props.theme.space['500']};
    grid-template-columns: 2fr auto 280px; /* NOTE: AlignedTextButton gets max width at the same time for this grid layout to work */

    @media (min-width: ${(props) => props.theme.breakpoints[3]}) {
      ${PriorityWrapper} {
        margin-right: 170px;
      }
    }
  }
`;

export const TableWrapper = styled.div`
  overflow-x: auto;

  & > * {
    margin-bottom: 0;
  }
`;

export const Label = ({ children }) => <Text fontWeight="medium">{children}</Text>;

export const PriorityHighTag = () => <Tag color="red">High Severity</Tag>;

export const PriorityMediumTag = () => <Tag color="yellow">Medium Severity</Tag>;

export const PriorityLowTag = () => <Tag color="lightGray">Low Severity</Tag>;
